import Route from '@ember/routing/route';

export default class ScreensStudioRoute extends Route {
  model(): void {
    return;
  }
}
